import { app } from 'apprun';
import { __, lang } from '../Txlat';
import { getAgencyLink, getUrl, getTrimUrl } from '../utility';
import InqueryTitle from '../agent-inquiry-title';

export default function ({ agent, agency }) {
  if (!agent) { return; }
  const getPreferedPhone = (agent) => {
    return (agent.mobile && agent.mobile !== '') ? agent.mobile : agent.phone;
  };
  const inqueryTitle = <InqueryTitle agent1={agent} agent2='' />;
  const emailSubject = `${__('Inquiry posted at rlpCommercial.com')}`;
  return (
    <div>
      <style>{'.btn-custom {color: #fff;background-color: #333333;border-color: #333333;}.btn-custom:focus, .btn-custom:focus:active {color: #fff;background-color: #333333;border-color: #333333;}.btn-custom:hover {color: #fff;background-color: #ea002a;border-color: #ea002a;}.btn-custom:active, .btn-custom:not(:disabled):not(:disabled):active {color: #fff;background-color: #ea002a;border-color: #ea002a;}'}</style>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="agent-image">
            <img width="700" height="700" src={agent.photo_path} class="img-fluid wp-post-image" $onerror='image-failed'></img>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="agent-profile-top-wrap">
            <div class="agent-profile-header">
              <h1>{agent.name}</h1>
            </div>
            <p class="agent-list-position">
              {((lang.get() === 'fr') ? agent.title_FR : agent.title)}<br />
            </p>
            <p></p>
          </div>

          <div class="agent-profile-content">
            <ul class="list-unstyled">
              {
                (agent.mobile && agent.mobile !== '')
                  ?
                  <li>
                    <strong>{__('Mobile')}:</strong> <a href={'tel:' + agent.mobile}>{agent.mobile}</a>
                  </li>
                  : ''
              }
              {
                (agent.phone && agent.phone !== '')
                  ?
                  <li>
                    <strong>{__('Office')}:</strong> <a href={'tel:' + agent.phone}>{agent.phone}</a>
                  </li>
                  : ''
              }
              {
                (agent.website && agent.website !== '')
                  ?
                  <li>
                    <strong>{__('Website')}:</strong> <a href={getUrl(agent.website)} target='_blank' style={'overflow-wrap: break-word;'} >{getTrimUrl(agent.website)}</a>
                  </li>
                  : ''
              }
              {
                (agent.regions_serviced && agent.regions_serviced !== '')
                  ?
                  <li>
                    <strong>{__('Service Areas')}:</strong> {agent.regions_serviced}
                  </li>
                  : ''
              }

              {
                (lang.get() === 'fr' ? agent.business_types_FR : agent.business_types)
                  ?
                  <li>
                    <strong>{__('Specialties')}:</strong>  {((lang.get() === 'fr') ? agent.business_types_FR : agent.business_types)}
                  </li>
                  : ''
              }
            </ul>
          </div>

          <div class="agent-profile-buttons">
            <a href='' $onclick={['/openInqueryModal', { inqueryTitle, email: agent.email, inquiryType: 'AgentInquiry', sub: emailSubject, agent1: agent, form_type: 'AgentProfile', formName: 'agentDetail' }]} class="btn btn-search btn-primary " style='color:white'>
              {__('Send Email')}
            </a>
            {
              (getPreferedPhone(agent) && getPreferedPhone(agent) !== '')
                ?
                <a href={'tel:' + getPreferedPhone(agent)} class="btn btn-custom">
                  <span class="hide-on-click">{__('Call')}</span>
                  <span class="show-on-click">{getPreferedPhone(agent)}</span>
                </a>
                : ''
            }
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12 text-break">
          <div class="agent-profile-top-wrap">
            <div class="agent-profile-header">
              <div class="item-title" style="white-space: normal;">
                <a target={'agency' + agency.id} href={getAgencyLink(agency)}><b>{agency.name}</b></a>
              </div>
              {agency.address}<br />
              {`${agency.city} ${agency.province} ${agency.postal_code}`}<br />
            </div>
          </div>

          {(agency.phone && agency.phone !== '') ? <div><strong>{__('Tel')}:</strong>&nbsp;<a href={'tel:' + agency.phone}><span class="agent-phone ">{agency.phone}</span></a><br /></div> : ''}
          {(agency.website && agency.website !== '') ? <div><a href={getUrl(agency.website)} target='_blank'>{getTrimUrl(agency.website)}</a><br /></div> : ''}
        </div>

      </div>
    </div>
  );
}
